module.exports = __webpack_public_path__ + "static/img/1_2_2.53796901.jpg";